import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function EmergencyPlumbingHero() {
  return <section id="emergencyplumbinghero" className="relative overflow-hidden bg-background py-20 md:py-32">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/5 via-background to-background"></div>

      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-8">
          {}
          <div className="max-w-2xl">
            <Badge variant="secondary" className="mb-6 px-3 py-1 text-sm">
              Plumbing Services
            </Badge>
            
            <h1 className="mb-4 font-default text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              Atlanta Plumbing Services — Expert Solutions for Every Pipe
            </h1>

            <h2 className="mb-4 font-default text-2xl font-semibold tracking-tight text-foreground/90 sm:text-3xl">
              Local Plumbing Services &amp; Prompt Repair Support
            </h2>

            <h3 className="mb-6 font-default text-lg font-medium text-muted-foreground sm:text-xl">
              Independent Local Plumbers Across Metro Atlanta
            </h3>
            
            <p className="mb-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Independent local plumbers offering comprehensive leak detection and repair. Connect with verified pros through our marketplace to help secure your home plumbing system. Explore our <Link to="#servicepricing" className="text-primary underline underline-offset-4 hover:text-primary/80">plumbing services</Link> or request a quote today.
            </p>

            <p className="mb-8 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Your pro gives a quote before work starts. Ready to connect with a plumber? <Link to="#bookingrequest" className="text-primary underline underline-offset-4 hover:text-primary/80">Request a quote</Link> right now.
            </p>
            
            <div className="flex flex-col gap-4 sm:flex-row">
              <Button size="lg" asChild className="h-12 px-8 text-base">
                <Link to="#bookingrequest">
                  Request a Quote
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-lg lg:ml-auto lg:max-w-none">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/atlanta_emergency_plumber_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/atlanta_emergency_plumber_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/atlanta_emergency_plumber_hero.png-wvc-sizes" alt="Independent local plumber fixing a pipe in Atlanta" className="aspect-[4/3] h-auto w-full object-cover lg:aspect-square" loading="eager" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 -z-10 h-32 w-32 rounded-lg bg-primary/20 blur-3xl"></div>
            <div className="absolute -right-6 -top-6 -z-10 h-32 w-32 rounded-lg bg-secondary/20 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>;
}